// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1Sbac","modalFooterButton":"ModalNotes_modalFooterButton__3IKw-"};